import { ImportColumnConfig } from './ImportState';
import { CsvCellContent, downloadAsCsv, FileName, generateXLSX } from '@retail/products/utils';
import type { ObjectSchema } from 'yup';
import { getISO_8601Date } from '@retail/utils';

export abstract class ImportItemsConfig<T> {
  abstract columns: ImportColumnConfig<Extract<keyof T, string>>[];
  abstract schema: ObjectSchema<any>;

  abstract templateExampleData: Record<keyof T, CsvCellContent[]>;

  downloadTemplateAsExcel = (fileName: string) => {
    const keys = Object.keys(this.templateExampleData) as Extract<keyof T, string>[];
    const columnMap = new Map(this.columns.map((col) => [col.name, col]));
    const headers = keys.map((key) => columnMap.get(key)?.recognizedColumnNames[0] ?? key);

    const rawRows = this.getTemplateRows();

    const rows = rawRows.map((row) =>
      row.map((cell) => {
        if (cell instanceof Date) {
          return getISO_8601Date(cell);
        }
        return cell;
      })
    );

    return generateXLSX({ rows: [headers, ...rows], fileName });
  };

  downloadTemplateAsCsv = (fileName: FileName) => {
    const keys = Object.keys(this.templateExampleData) as Extract<keyof T, string>[];
    const columnMap = new Map(this.columns.map((col) => [col.name, col]));
    const headers = keys.map((key) => columnMap.get(key)?.recognizedColumnNames[0] ?? key);

    const rows = this.getTemplateRows();

    downloadAsCsv({
      headers,
      rows,
      fileName,
    });
  };

  private getTemplateRows = () => {
    const keys = Object.keys(this.templateExampleData) as Extract<keyof T, string>[];
    const rowCount = this.templateExampleData[keys[0]]?.length ?? 0;

    return Array.from({ length: rowCount }, (_, rowIndex) =>
      keys.map((key) => this.templateExampleData[key][rowIndex])
    );
  };
}
